import { render, staticRenderFns } from "./authRoleUser.vue?vue&type=template&id=2c0e6f49&scoped=true&"
import script from "./authRoleUser.vue?vue&type=script&lang=js&"
export * from "./authRoleUser.vue?vue&type=script&lang=js&"
import style0 from "./authRoleUser.vue?vue&type=style&index=0&id=2c0e6f49&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0e6f49",
  null
  
)

export default component.exports